import { classNames } from './classNames';
import theme from './theme.scss';

export default {
    bind(el, binding) {
        const className = classNames('d', {...binding.modifiers}, binding.value);
        el.className += ' ' + theme[className];
    },
};



// WEBPACK FOOTER //
// ./src/baseComponents/directives/Display/Display.js